import { PAGE_PATH } from '@/constants';
import { fetchMatomoSiteId, fetchOpenId } from '@/services';
import { getWechatMpLoginInfo } from '@/services/login/wechatMp';
import uniMatomo from '@/services/matomo';
import { useAppStore, useCustomStore, useUserStore } from '@/store';

export default {
  load: async () => {
    // #ifdef MP
    // 初始化matomo
    const res = await fetchMatomoSiteId();
    uniMatomo.init(res);
    // 查询用户信息是否存在
    const hasUser = uniMatomo.checkUserId();
    if (!hasUser) {
      // 不存在则获取openid，然后上报绑定
      const loginRes = await getWechatMpLoginInfo();
      let oid = await fetchOpenId(loginRes.code);
      // 先设置缓存
      uniMatomo.setUserId(oid);
      // 设置pkid
      uniMatomo.setPkId(oid);
      // console.log(`[ uniMatomo ] => 用户信息不存在，获取openid然后上报绑定: ${oid}`);
      uniMatomo.bindUser(oid);
    } else {
      // 存在则获取缓存的id进行上报绑定
      let uid = uniMatomo.getUserId();
      // 设置pkid
      uniMatomo.setPkId(uid);
      // console.log(`[ uniMatomo ] => 用户信息存在，获取缓存id进行上报绑定: ${uid}`);
      uniMatomo.bindUser(uid);
    }
    // #endif
    // 通知需要上报的页面，初始化已完成，用户已绑定
    useAppStore().isMatomoReady = true;
    // console.log(`[ uniMatomo ] => 通知需要上报的页面，初始化已完成，用户已绑定`);
  },
  /**
   * 下单商品上报
   * @param clickType
   * @param productId
   * @param skuId
   * @param addCartCount
   * @param orderAmount
   */
  placeOrder: async (
    clickType: string,
    productId: string,
    skuId: string,
    addCartCount: number,
    orderAmount: number
  ) => {
    if (clickType === 'addCart') {
      // 商品
      uniMatomo.trackEvent('Cart', 'Product_Add_Cart', `Cart_Product_${productId}`, addCartCount);
      // sku
      uniMatomo.trackEvent('Cart', 'Sku_Add_Cart', `Cart_Sku_${skuId}`, addCartCount);

      const userInfo = await useUserStore().getUserInfo(true);
      const distributorId = userInfo?.distributor?.id;
      // 分销中心 - 商品加购上报
      if (distributorId && productId) {
        // 商品
        uniMatomo.trackEvent(
          'Distribution_Cart',
          'Distribution_Product_Add_Cart',
          `Distribution_${distributorId}_Cart_Product_${productId}`,
          addCartCount
        );
        // sku
        uniMatomo.trackEvent(
          'Distribution_Cart',
          'Distribution_CartSku_Distributor_Add_Cart',
          `Distribution_${distributorId}_Cart_Sku_${skuId}`,
          addCartCount
        );
      } else {
        console.log(`<分销中心 - 商品加购上报>`, {
          distributorId,
          productId,
          skuId,
        });
      }
    } else {
      // 商品下单件数
      uniMatomo.trackEvent(
        'Order',
        'Product_Order_Count',
        `Order_Count_Product_${productId}`,
        addCartCount
      );
      // sku下单件数
      uniMatomo.trackEvent('Order', 'Sku_Order_Count', `Order_Count_Sku_${skuId}`, addCartCount);
      // 商品下单金额
      uniMatomo.trackEvent(
        'Order',
        'Product_Order_Amount',
        `Order_Amount_Product_${productId}`,
        orderAmount
      );
      // 商品下单金额
      uniMatomo.trackEvent('Order', 'Sku_Order_Amount', `Order_Amount_Sku_${skuId}`, orderAmount);
    }
  },
  customPageClick: () => {
    const customStore = useCustomStore();
    const pages = getCurrentPages();
    const curPage = `/${pages[pages.length - 1].route}`;

    const type = `ActivityPage`;
    const action = `ActivityPage_Click`;
    const namePrefix = `ActivityPage_`;
    const value = 1;

    if (curPage === PAGE_PATH.home.route) {
      uniMatomo.trackEvent(type, action, `${namePrefix}${customStore.homeCustomId}`, value);
    } else if (curPage === PAGE_PATH.classify.route) {
      uniMatomo.trackEvent(type, action, `${namePrefix}${customStore.classifyCustomId}`, value);
    } else if (curPage === PAGE_PATH.activity.route) {
      uniMatomo.trackEvent(type, action, `${namePrefix}${customStore.activityCustomId}`, value);
    }
  },
};
